<template>
  <div>
    <rueden-header :title="'Anwaltliches Mahnschreiben beantragen'"/>

    <!-- 1 Anspruch -->
    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 1">

      <schrittanzeige
        :step="step"
        :last="stepCount"
        :title="'Bezeichnen Sie bitte nachstehend Ihren Anspruch'"
      />

      <form name="mahnbescheid_beantragen_1" id="form_1">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="formular-box">

              <div class="row">
                <div class="col-12">
                  <h2 class="mt-0 pt-0 mb-0 pb-4 pb-md-5">1. Daten zum Anspruch</h2>
                </div>
              </div>

              <suggest-input
                key="FalldatenAnspruchsart"
                v-model="falldaten.anspruchsart"
                label="Anspruchsgrund / Vertragsart"
                :list="['Darlehensvertrag',
                  'Dienstleistungsvertrag',
                  'Handwerkerleistung',
                  'Kaufvertrag',
                  'Mietvertrag',
                  'Werkvertrag',
                  'Mietkosten',
                  'Werklieferungsvertrag',
                  'Schadensersatz jeglicher Art',
                  'Ärztliche oder zahnärztliche Leistung',
                  'Tierärztliche Leistung',
                  'Maklerlohn',
                  'Speditionskosten',
                  'Frachtkosten',
                  'Geschäftsbesorgungen',
                  'Unterhaltsrückstände',
                  'Hotelkosten',
                  'Leasing/Mietkauf',
                  'Lehrgangs-/Unterrichtskosten',
                  'Pacht',
                  'Reparaturleistungen',
                  'Zinsrückstände',
                ]"
                :required="true"
              />

              <div v-if="falldaten.anspruchsart && falldaten.anspruchsart.toLowerCase() == 'mietvertrag'" class="row">
                <text-input
                  key="FalldatenMietobjektPostleitzahl"
                  v-model="falldaten.mietobjekt.postleitzahl"
                  label="PLZ des Mietobjekts"
                  type="zip"
                  :required="true"
                />
                <text-input
                  key="FalldatenMietobjektOrt"
                  v-model="falldaten.mietobjekt.ort"
                  label="Ort des Mietobjekts"
                  :required="true"
                />
              </div>

              <div class="row">
                <text-input
                    key="FalldatenBemerkungen"
                    v-model="falldaten.bemerkungen"
                    label="Kundennummer / Rechnungsnummer (falls vorhanden)"
                    col="col-12"
                    placeholder="(Optional)"
                    tooltip="Bitte bezeichnen Sie hier den genauen Grund wesegwen Sie Anspruch erheben. Der Antragsgegner muss erkennen können, um welchen Anspruch es sich handelt. Dies kann durch eine eindeutige Rechnungsnummer (bei Gewerbetreibenden) geschehen oder durch eine kleine Schilderung des Sachverhaltes (bei Privatpersonen)."
                />
              </div>

              <div class="row">
                <text-input
                  key="FalldatenFaelligkeit"
                  v-model="falldaten.faelligkeit"
                  label="Fälligkeit"
                  type="date"
                  :required="true"
                  tooltip="Fälligkeit bezeichnet den Eintritt des Leistungstermin und die damit verbundene, sofortige Leistungspflicht des Schuldners."
                />
                <text-input
                  key="FalldatenBetrag"
                  v-model="falldaten.betrag"
                  label="Betrag"
                  type="currency"
                  :required="true"
                  tooltip="Tragen Sie hier den genauen Betrag der Hauptforderung ein (OHNE Nebenkosten, Zinsen, Anwaltskosten, o.ä.)"
                />
              </div>

              <div class="row mt-3">
                <div class="col-12">
                  <p>
                    Auf welche Bankverbindung soll im Falle des Erfolges die Auszahlung erfolgen?
                  </p>
                </div>

              </div>
              <div class="row">
                <text-input
                  key="Bankverbindung"
                  v-model="falldaten.bank"
                  label="IBAN"
                  type="iban"
                  col="col-12"
                  :required="true"
                />
              </div>

              <next-back-step
                key="nextBack1"
                v-model="step"
              />

            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- 2. Antragsgegner -->
    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 2">
      <schrittanzeige
        :step="step"
        :last="stepCount"
        :title="'Bitte geben Sie hier die Daten des Schuldners ein.'"
      />

      <form name="mahnbescheid_beantragen_2" id="form_2">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="formular-box">

              <div class="row">
                <div class="col-12">
                  <h2 class="mt-0 pt-0 mb-0 pb-4 pb-md-5">2. Daten des Schuldners</h2>
                </div>
              </div>

              <div class="row">
                <select-input
                  key="FalldatenGegnerAnrede"
                  v-model="falldaten.gegner.anrede"
                  :list="[
                    {text: 'Frau', value: 'Frau'},
                    {text: 'Herr', value: 'Herr'},
                    {text: 'Einzelunternehmen', value: 'Einzelunternehmen'},
                    {text: 'GmbH', value: 'GmbH'},
                    {text: 'UG', value: 'UG'},
                    {text: 'GmbH & Co. KG', value: 'GmbH & Co. KG'},
                    {text: 'GbR', value: 'GbR'},
                    {text: 'AG', value: 'AG'},
                    {text: 'e.V.', value: 'e.V.'},
                    {text: 'OHG', value: 'OHG'},
                  ]"
                  col="col-12- col-md-6"
                  label="Anrede / Firma"
                  :required="true"
                />
                <text-input v-if="isFirma(falldaten.gegner.anrede)"
                  key="FalldatenGegnerFirmenname"
                  v-model="falldaten.gegner.firmenname"
                  label="Firmenname"
                  col="col-12 col-md-6"
                  :required="true"
                />
              </div>

              <div v-if="!isFirma(falldaten.gegner.anrede)" class="row">
                <text-input
                  key="FalldatenGegnerVorname"
                  v-model="falldaten.gegner.vorname"
                  label="Vorname"
                  :required="true"
                />
                <text-input
                  key="FalldatenGegnerNachname"
                  v-model="falldaten.gegner.nachname"
                  label="Nachname"
                  :required="true"
                />
              </div>

              <address-input
                key="FalldatenGegnerAdresse"
                v-model="falldaten.gegner.adresse"
                label="Adresse"
                :required="true"
                tooltip="Es sind nur Adressen aus Deutschland zulässig."
                :countries="['de']"
              />

              <div class="row">
                <select-input
                  key="FalldatenGegnerZustellung"
                  v-model="falldaten.gegner.zustellung"
                  :list="[
                    {text: 'Fax', value: 'Fax'},
                    {text: 'Online', value: 'Online'},
                    {text: 'Einschreiben mit Rückschein (+9,90€)', value: 'Einschreiben mit Rückschein (+9,90€)'},
                  ]"
                  col="col-12"
                  label="Wie soll das Schreiben zugestellt werden?"
                  :required="true"
                />
              </div>

              <div v-if="['Fax', 'Online'].includes(falldaten.gegner.zustellung)" class="row">
                <text-input
                    v-if="falldaten.gegner.zustellung == 'Fax'"
                    key="FalldatenGegnerFax"
                    v-model="falldaten.gegner.fax"
                    label="Fax"
                    type="tel"
                    :required="true"
                    col="col-12 col-md-12"
                />
                <text-input
                    v-if="falldaten.gegner.zustellung == 'Online'"
                    key="FalldatenGegnerEmail"
                    v-model="falldaten.gegner.email"
                    label="E-Mail"
                    type="email"
                    :required="true"
                    col="col-12 col-md-12"
                />
              </div>

              <next-back-step
                key="nextBack2"
                v-model="step"
              />

            </div>
          </div>
        </div>

      </form>

    </div>

    <!-- 3. Antragssteller  -->
    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 3">
      <form name="mahnbescheid_beantragen_3" id="form_3" autocomplete="off">
        <schrittanzeige
          :step="step"
          :last="stepCount"
          :title="'Tragen Sie bitte erst die Daten des Antragsstellers ein.'"
        />

        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="formular-box">
              <div class="row">
                <div class="col-12">
                  <h2 class="mt-0 pt-0 mb-0 pb-4 pb-md-5">3. Daten des Antragsstellers</h2>
                </div>
              </div>
              <!-- anrede/rechtsform als dropdown für herr/frau/hier die rechtsformen auflisten
            vorname/nachname pflicht bei herr/frau ... sonst firmenname für firmaauswahl-->
              <div class="row">
                <select-input
                  key="StammdatenAnrede"
                  v-model="stammdaten.anrede"
                  :list="[
                    {text: 'Frau', value: 'Frau'},
                    {text: 'Herr', value: 'Herr'},
                    {text: 'Einzelunternehmen', value: 'Einzelunternehmen'},
                    {text: 'GmbH', value: 'GmbH'},
                    {text: 'UG', value: 'UG'},
                    {text: 'GmbH & Co. KG', value: 'GmbH & Co. KG'},
                    {text: 'GbR', value: 'GbR'},
                    {text: 'AG', value: 'AG'},
                    {text: 'e.V.', value: 'e.V.'},
                    {text: 'OHG', value: 'OHG'},
                  ]"
                  col="col-12- col-md-6"
                  label="Anrede / Firma"
                  :required="true"
                />
                <text-input v-if="isFirma(stammdaten.anrede)"
                  key="StammdatenFirmenname"
                  v-model="stammdaten.nachname"
                  label="Firmenname"
                  type="text"
                  :required="true"
                />
              </div>

              <div v-if="['Frau', 'Herr'].includes(stammdaten.anrede)" class="row">
                <text-input
                  key="StammdatenVorname"
                  v-model="stammdaten.vorname"
                  label="Vorname"
                  type="text"
                  :required="true"
                />
                <text-input
                  key="StammdatenNachname"
                  v-model="stammdaten.nachname"
                  label="Nachname"
                  type="text"
                  :required="true"
                />
              </div>

              <address-input
                key="StammdatenAdresse"
                v-model="stammdaten.adresse"
                label="Adresse"
                :required="true"
                :countries="['de']"
              />

              <div class="row">
                <text-input
                  key="StammdatenEmail"
                  v-model="stammdaten.email"
                  label="E-Mail"
                  type="email"
                  :required="true"
                  tooltip="Wir werden Sie im Laufe des Verfahrens per E-Mail stets auf dem aktuellen Stand halten. Sie erhalten nach der Verarbeitung ebenfalls eine Bestätigung per E-Mail."
                />
                <select-input
                  key="FalldatenVorsteuerabzugsberechtigt"
                  v-model="falldaten.vorsteuerabzugsberechtigt"
                  label="Berechtigung zum Vorsteuerabzug"
                  col="col-12"
                  placeholder="bitte wählen"
                  tooltip="Bei Privatpersonen ist immer 'NEIN' auszuwählen. Vorsteuerabzugsberechtigt ist jeder Unternehmer, der nicht der Kleinunternehmerregelung unterliegt und seine Einnahmen sowie Ausgaben inklusive Mehrwertsteuer tätigt."
                  :required="true"
                  :list="[
                    {text: 'Ja', value: 'Ja'},
                    {text: 'Nein', value: 'Nein'},
                    {text: 'Weiß ich nicht', value: 'Weiß ich nicht'},
                  ]"
                />
              </div>

              <next-back-step
                key="nextBack3"
                v-model="step"
              />

            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 4">
      <form name="mahnbescheid_beantragen_4" id="form_4" autocomplete="off">
        <schrittanzeige
          :step="step"
          :last="stepCount"
          :title="'Bitte bestätigen Sie uns die geforderten Pflichtfelder, damit wir den Auftrag entgegennehmen können.'"
        />

        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="formular-box">
              <div class="row">
                <div class="col-12">
                  <h2 class="mt-0 pt-0 mb-0 pb-4 pb-md-5">4. Auftrag bestätigen</h2>
                </div>
              </div>

              <!-- richtigkeit der daten als checkbox rein, rest bleibt, kosten aufnehmen als info: 79 euro + evt. einschreibungskosten -->
              <div class="row mb-3">
                <select-input
                  key="AcceptRichtigkeit"
                  v-model="acceptRichtigkeit"
                  :required="true"
                  label="Hiermit bestätige ich, dass alle Angaben vollständig und wahrheitsgemäß eingetragen wurden."
                />
              </div>

              <div class="row mb-3">
                <select-input
                  key="AcceptWr"
                  v-model="acceptWr"
                  :required="true"
                  :isWR="true"
                />
              </div>
              <div class="row mb-3">
                <select-input
                  key="AcceptDs"
                  v-model="acceptDs"
                  :required="true"
                  :isDS="true"
                />
              </div>

              <div class="row pt-4">
                <div class="col-12">
                  <div class="alert alert-info">
                    <p class="m-0">Für den Auftrag entstehen mir folgenden Kosten: <span class="font-weight-bold">79€ inkl. MwSt <span v-if="falldaten.gegner.zustellung == 'Einschreiben mit Rückschein (+9,90€)'">zzgl. 9,90€ (per Einschreiben)</span></span></p>
                  </div>
                </div>
              </div>

              <next-back-step
                key="nextBack4"
                v-model="step"
                submitButton="Kostenpflichtig beauftragen"
              />

            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="container pt-4 pt-md-5 pb-5" v-if="step === 5">
      <schrittanzeige
          :step="step"
          :last="stepCount"
          :title="'Anwaltsschreiben - Beantragung'"
      />
      <abschluss
        :error="error"
      />
    </div>

    <!-- datenschutzlogo immer anzeigen im formular -->
    <rueden-footer
      :show_berlin="true" />

  </div>
</template>
<script>
import TextInput from "@/components/all/text-input";
const STEP_COUNT = 5;

import General from '@/mixins/general';

import RuedenHeader from '@/components/all/rueden-header';
import Schrittanzeige from '@/components/all/schrittanzeige';
import SelectInput from "@/components/all/select-input";
import AddressInput from "@/components/all/address-input";
import NextBackStep from "@/components/all/next-back-buttons";
import RuedenFooter from "@/components/all/rueden-footer";
import Abschluss from "@/components/all/abschluss";
import SuggestInput from "@/components/all/suggest-input";

export default {

  mixins: [General],

  components: {
    RuedenFooter,
    Abschluss,
    TextInput,
    AddressInput,
    RuedenHeader,
    Schrittanzeige,
    SelectInput,
    NextBackStep,
    SuggestInput,
  },

  data() {
    return {
      stepCount: STEP_COUNT,
      step: 1,
      acceptWr: null,
      acceptRichtigkeit: null,
      acceptDs: null,
      stammdaten: {
        anrede: 'Frau',
        adresse: {}
      },
      falldaten: {
        anspruchsart: this.$route.query.vertragsart,
        gegner: {
          anrede: 'Frau',
          adresse: {},
        },
        mietobjekt: {},
        nebenkosten: {}
      },
      error: null,
    }
  },
  mounted() {
    document.title = 'Anwaltsschreiben - Jetzt beantragen';
    this.$global.gaCat = 'Lead Funnel Anwaltsschreiben';
  },
  watch: {
    step: function (curStep) {
      if (curStep == this.stepCount) {
        this.error = this.submitToFlowGeneral(this.stammdaten,'Anwaltsschreiben',this.falldaten);
      }
    },
    stammdaten: function (v) {
      if (this.isFirma(v.anrede)) {
        this.stammdaten.vorname = v.anrede;
      } else {
        this.stammdaten.vorname = null
      }
    },
  }
}
</script>
